import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=f971bdce"
import script from "./CopyLink.vue?vue&type=script&lang=js"
export * from "./CopyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f971bdce')) {
      api.createRecord('f971bdce', component.options)
    } else {
      api.reload('f971bdce', component.options)
    }
    module.hot.accept("./CopyLink.vue?vue&type=template&id=f971bdce", function () {
      api.rerender('f971bdce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/CopyLink.vue"
export default component.exports